import { useTranslation } from 'react-i18next';
import { Col, Row, Card, Divider } from 'antd';
import { BlockHeader } from '../../BlockHeader';
import useNumberFormatter from '../../../../hooks/format/useNumberFormatter';
import React from 'react';
import { ReactComponent as TableIcon } from 'assets/img/icons/sodraTable.svg';
import { ReactComponent as YarlyIcon } from 'assets/img/icons/sodraAmount.svg';
import { ReactComponent as ChartIcon } from 'assets/img/icons/sodraChart.svg';
import { SocialSecurityGraph } from '../../graphs/SocialSecurityGraph/SocialSecurityGraph';

const SocialSecurityContributions = ({ tableData = [], chartData = [] }) => {
  const { t } = useTranslation();
  const formatCurrency = useNumberFormatter();

  return (
    <>
      <Col xs={24} sm={24} md={24} lg={18} xl={16} xxl={12}>
        <Card className="card-small card-simple card-simple-padding-none space-vertical-sm has-shadow">
          <Row justify="start" align="middle">
            <Col>
              <BlockHeader
                icon={<TableIcon className="icon--gray" />}
                title={t('professionalReport.basicData.socialSecurityTable.title')}
              />
            </Col>
          </Row>
          <Card className="card-simple card-simple-padding-none has-shadow" style={{ width: '100%' }}>
            <Row>
              <Col span={3}>
                <YarlyIcon />
              </Col>
              {tableData.length && chartData.length ? (
                tableData.map((singleYear, index) => (
                  <>
                    {index !== 0 ? (
                      <Col span={1}>
                        <Divider type="vertical" style={{ height: '100%' }} />
                      </Col>
                    ) : null}
                    <Col span={6}>
                      <Row>
                        <Col span={24} className="fw-700 fs-16">
                          {singleYear?.amount ? formatCurrency(singleYear.amount) : '-'}
                        </Col>
                        <Col span={24}>{singleYear.year}</Col>
                      </Row>
                    </Col>
                  </>
                ))
              ) : (
                <>
                  <Col span={1}>
                    <Divider type="vertical" style={{ height: '100%' }} />{' '}
                  </Col>{' '}
                  <Col span={20} className="align-items-center">
                    {t('professionalReport.basicData.socialSecurityTable.noInformation')}
                  </Col>
                </>
              )}
            </Row>
          </Card>
        </Card>
      </Col>
      {tableData.length && chartData.length ? (
        <Card className="card-simple card-simple-padding-none space-vertical-sm has-shadow" style={{ width: '100%' }}>
          <Row justify="start" align="middle">
            <Col>
              <BlockHeader icon={<ChartIcon />} title={t('professionalReport.basicData.socialSecurityChart.title')} />
            </Col>
          </Row>
          <Row className="no-break" style={{ pageBreakInside: 'avoid', pageBreakAfter: 'auto' }}>
            <Col md={24} lg={24}>
              <SocialSecurityGraph chartData={chartData} />
            </Col>
          </Row>
        </Card>
      ) : null}
    </>
  );
};

export default SocialSecurityContributions;
